import type { VertiNodeLocale, VertiNodeLocalizedString } from "../../../../core/schema/VertiNodeLocale.js";
import { nbspify } from "../../../../core/utils/nbspify.js";
import { getGlobalSettings } from "../getGlobalSettings.js";

function translate<Translations extends Record<string, VertiNodeLocalizedString>, Key extends keyof Translations>(
	translations: Translations,
	key: Key,
	locale: VertiNodeLocale,
	variables: Record<string, string | number> = {},
	disableNbspify: boolean,
): Translations[Key][VertiNodeLocale] {
	const translation = translations[key]?.[locale];
	let finalTranslation = String(translation ?? key);
	for (const [variable, value] of Object.entries(variables)) {
		finalTranslation = finalTranslation.replaceAll(`{{${variable}}}`, String(value));
	}
	// We want this globally in this project, so we replace it here to make sure it is always applied.
	finalTranslation = finalTranslation.replaceAll(/VertiNode(?!['’])/gu, "VertiNode®");
	const text = finalTranslation as Translations[Key][VertiNodeLocale];
	if (disableNbspify) {
		return text;
	}
	return nbspify(text);
}

export function getTranslate<Translations extends Record<string, VertiNodeLocalizedString>>(
	translations: Translations,
) {
	const { TENANT_LOCALE } = getGlobalSettings();
	return <Key extends keyof Translations>(
		key: Key,
		variables: Record<string, string | number> = {},
		disableNbspify = false,
	): Translations[Key][VertiNodeLocale] => {
		return translate<Translations, Key>(translations, key, TENANT_LOCALE, variables, disableNbspify);
	};
}
